module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Regular.fdc0354.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/font/sourcesans/SourceSansPro-Regular.woff
// module id = 705
// module chunks = 3